import {
  FAILED,
  LOADING, MERCHANT_VERIFICATION_FAILED,
  MERCHANT_VERIFICATION_LOADING,
  MERCHANT_VERIFICATION_SET_DATA,
  MERCHANT_VERIFICATION_SET_FILTER, SUCCESS
} from './constants';

import {
  approveMerchantRegistration,
  merchantRegistrationList,
  processVerification,
  rejectMerchantRegistration,
  revitionMerchantRegistration
} from '../../utils/api';
import {
  filterBuilder
} from '../../utils/builder/verificationRegistrationMerchant';
import { initialState } from './reducer';

export function fetchMerchantRegistrationList(
  nextPage = 1,
  search = '',
  filter = initialState.filter,
  initial = true
) {
  return async (dispatch, getState) => {
    const state = getState();
    const { page, totalPage } = state.merchantVerification.meta;
    if (!initial && page > 1 && page >= totalPage) {
      return;
    }
    try {
      dispatch({ type: MERCHANT_VERIFICATION_LOADING, loading: true });
      const params = {
        ...filter,
        search,
        size: 100,
        page: nextPage,
      };

      const { data, meta } = await merchantRegistrationList(
        filterBuilder(params)
      );
      dispatch({ type: MERCHANT_VERIFICATION_SET_DATA, data, meta, initial });
    } catch (error) {
      dispatch({ type: MERCHANT_VERIFICATION_FAILED, message: error.message });
    }
  };
}

export function setMerchantVerificationFilter(filter) {
  return async (dispatch) => {
    dispatch({
      type: MERCHANT_VERIFICATION_SET_FILTER,
      filter,
    });
  };
}

export const clearDetail = () => {
  return async (dispatch) => {
    const key = 'MerchantRegistrationDetail';
    dispatch(successAction([], key));
    dispatch(loadingAction(true, key));
  };
};

export const submitProcess = (params, process = false) => {
  return async (dispatch) => {
    const key = 'MerchantRegistrationDetail';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await processVerification(params);
      dispatch(successAction(data, key));
      dispatch(loadingAction(false, key));
      dispatch(successAction(false, 'SubmitRevition'));
      dispatch(successAction(false, 'SubmitApproved'));
      dispatch(successAction(false, 'SubmitRejected'));
      dispatch(failedAction('', 'SubmitRevition'));
      dispatch(failedAction('', 'SubmitApproved'));
      dispatch(failedAction('', 'SubmitRejected'));
      dispatch(successAction(process, 'OnProcess'));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submitDetail = (data) => {
  return async (dispatch) => {
    const key = 'MerchantRegistrationDetail';
    dispatch(successAction(data, key));
  };
};

export const submitApprove = (registrationId, callback = () => {}) => {
  return async (dispatch) => {
    const key = 'SubmitApproved';
    dispatch(loadingAction(true, key));
    callback();
    try {
      await approveMerchantRegistration(registrationId);
      dispatch(successAction(true, key));
      dispatch(successAction(true, 'OnProcess'));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submitRevition = (params, registrationId, callback = () => {}) => {
  return async (dispatch) => {
    const key = 'SubmitRevition';
    dispatch(loadingAction(true, key));
    callback();
    try {
      await revitionMerchantRegistration(registrationId, params?.reason);
      dispatch(successAction(true, key));
      dispatch(successAction(true, 'OnProcess'));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submitReject = (params, registrationId, callback = () => {}) => {
  return async (dispatch) => {
    const key = 'SubmitRejected';
    dispatch(loadingAction(true, key));
    callback();
    try {
      await rejectMerchantRegistration(registrationId, params.reason);
      dispatch(successAction(true, key));
      dispatch(successAction(true, 'OnProcess'));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};


export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key) {
  return { type: SUCCESS, data, key };
}
